// Mirrors GPMetals.Core.Models.Part.PartSyncErrorDto.
import { Marketplace } from "./Publishing";

export interface IPartSyncError {
  id: string;
  marketplace: Marketplace;
  /** The call that failed - "UpdateProduct", "CreateProduct", "NoStore", "Exception", ... */
  operation?: string | null;
  statusCode?: number | null;
  /** Short reason, safe for a table cell or tooltip. */
  message?: string | null;
  /** The bridge's response body verbatim - what "View raw error" shows. */
  rawResponse?: string | null;
  externalProductId?: string | null;
  store?: string | null;
  isResolved: boolean;
  resolvedOn?: string | null;
  created: string;
}

/**
 * Raw bodies come back as a JSON string. Pretty-print it where it parses, and fall back to the
 * original text where it doesn't - a 500 often returns an HTML error page, which is still the
 * most useful thing we can show.
 */
export function formatRawResponse(raw?: string | null): string {
  if (!raw) return "";

  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}
